import { DocumentoConciliableType } from "api/Types/DocumentoConciliable"
import { DOCUMENTO_CONCILIABLE_TYPE } from "features/Tesoreria/pages/Bancos/constants/DocumentoConciliableType"
import { TFunction } from "i18next"
import { frontendCurrency } from "utils/formatCurrency"

export const MODAL_DOCUMENTOS_CONCILIADOS_COLUMNS = (t: TFunction) => [
  {
    key: "identificador",
    title: `${t("bancos.idView.modalReconciled.table.headerIdentificator")}`,
    dataIndex: "identificador",
    className: "tw-text-base !tw-pl-6 [&>*_td]:!tw-py-0",
    width: "50%",
  },
  {
    key: "tipo",
    title: `${t("bancos.idView.modalReconciled.table.headerType")}`,
    render: (cell: DocumentoConciliableType) =>
      DOCUMENTO_CONCILIABLE_TYPE(t)[cell].label,
    dataIndex: "tipo",
    className: "tw-text-base [&>*_td]:!tw-py-0",
    width: "50%",
  },
  {
    key: "importe",
    title: `${t("bancos.idView.modalReconciled.table.headerImport")}`,
    render: (cell: number) => frontendCurrency(cell),
    dataIndex: "importe",
    className: "tw-text-base tw-text-right !tw-pr-8 [&>*_td]:!tw-py-0",
    width: "50%",
  },
]
